import effectManager from '../effect';
import animationManager from '../animation';

let effect;

/* ---------------------------------------

    -- スクロール位置で発火するやつはここ

--------------------------------------- */
export default class ScrollAnimation{
    constructor(inc){

        effect = new effectManager();

        this.$target = $('.js__tsc');
        this.scPoint = [];
        this.scNum = this.$target.length;


        effect.splitText($(".js__tsc-splittext"),"set");
        effect.show($(".js__tsc-show"),"set");
        effect.scale($(".js__tsc-scale"),"set");
        this.resize();

        this.status = {
            comp : false /* 全部処理が終わったか */
        }

    }
    check(inc,$container){

        if(this.status.comp) return;



        if(this.$target){
            for(var i=0; this.scNum>i; i++){

                if(this.scPoint[i] < inc  ) {

                    let $scp = this.$target.eq(i);
                    if(!$scp.hasClass("is-show")){
                        $scp.addClass("is-show");

                        let _$splitText = $scp.find(".js__tsc-splittext >* >*");
                        let _$show = $scp.find(".js__tsc-show");
                        let _$scale = $scp.find(".js__tsc-scale");


                        if(_$splitText[0]) effect.splitText(_$splitText,"show");
                        if(_$show[0]) effect.show(_$show,"show");
                        if(_$scale[0]) effect.scale(_$scale,"show");

                        /* 商品紹介センテンス用 */
                        // if($scp.find(".js__tsc-svg")[0]) animation.svgPathMorph($("#flora_care_pkg_bg-none-svg"),["#flora_care_pkg_bg-svg"],"normal",1.98);
                        /* 手書き */
                        // if(_$svg[0]) effect.svgAnimation(_$svg,0.05);


                        if(i==this.$target.length-1) this.status.comp = true;

                        // if($scp.find(".js__sc_show")[0]) effect.scrollAnimation($scp,"show");
                        // if($scp.find(".js__sc_show-block")[0]) animation.panel($scp,"show");

                    }

                }

            }

            // if($container.find(".js__tsc.is-show").length === $container.find(".js__tsc").length)
            //     this.status.comp = true;
        }

    }

    resize (winH) {


        if(this.$target){
            // if(this.status.comp) return;
            let _minusPoint = (Useragnt.pc)?winH/1.5:winH;
            this.scPoint = [];
            for( var i=0; i<this.scNum; i++) {

                let $scp = this.$target.eq(i);

                this.scPoint[i] = $scp.offset().top - _minusPoint;
            }
        }

    }
}